// latest: zhangmyh 2017-8-9 10:32 AM
// 已经存在的物资分类
import { Collection } from 'common'
import 'collection/materialClass/existed.js'
/* global $ u */

let _config
function init (refer) {
  // 每次都重新加载
  let selectedData
  let collection = Collection.create('materialclass.existedlist')
  if (_config.model) {
    collection.load({}, {
      localData: {
        result: _config.model.getSimpleData()
      }
    })
  }

  let vm = {
    gridconfig: {
      id: 'mtrclassexist_grid',
      data: collection,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: false,
      fields: [{
        field: 'materialClassName',
        dataType: 'String',
        title: '名称',
        width: '39%'
      }, {
        field: 'materialClassFullpath',
        dataType: 'String',
        title: '全路径',
        width: '60%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#mtrclassexist_refer')[0])

  // 提交事件
  refer.registerSubmitFunc(() => {
    return selectedData
  })
  collection.datatable.on('select', function (obj) {
    let selectData = collection.datatable.getCurrentRow().data
    selectedData = {
      materialClassId: selectData.materialClassId.value,
      materialClassName: selectData.materialClassName.value,
      materialClassFullpath: selectData.materialClassFullpath.value
    }
    refer.submit()
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    model: null
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/materialClass/existed/index.js